import { SoSelectObjectItem } from "@/types/components/SoSelect"

export const TITLE_OPTIONS: SoSelectObjectItem[] = [
  { value: "Mr", title: "Mr" },
  { value: "Mrs", title: "Mrs" },
  { value: "Miss", title: "Miss" },
  { value: "Ms", title: "Ms" },
  { value: "Dame", title: "Dame" },
  { value: "Dr", title: "Dr" },
  { value: "Lady", title: "Lady" },
  { value: "Lord", title: "Lord" },
  { value: "Mx", title: "Mx" },
  { value: "Prof", title: "Prof" },
  { value: "Rev", title: "Rev" },
  { value: "Sir", title: "Sir" },
  { value: "Sister", title: "Sister" },
]
